import { render, staticRenderFns } from "./Whaoo.vue?vue&type=template&id=5fc1b340&"
import script from "./Whaoo.vue?vue&type=script&lang=js&"
export * from "./Whaoo.vue?vue&type=script&lang=js&"
import style0 from "./Whaoo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports